import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import { useQuery } from "react-query"
import { useDispatch, useSelector } from "react-redux"
import { Redirect } from "react-router"
import GlobalHelper from "../../common/GlobalHelper"
import Icon from "../../common/icon/icon.component"
import SideBar from "../../common/layout/sidebar.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import PaymentProcessingService from "../../payment-account/service/paymentprocessingService"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { setMerchantID } from "../../state/payment-processor/reducer"
import { RootState } from "../../state/store"
import { SESSION_TYPE } from "../../utils"
import PaymentProcessingTabs from "../PaymentProcessingTabs"
import PaymentStatusesModal from "../modals/PaymentStatusesModal"
import { useBaseModal } from "../modals/useBaseModal"
import {
    useGetPaymentAccounts,
    usePaymentAccountSessionByMerchantId
} from "../usePaymentAccountSession"
import NoPaymentsProcessed from "./NoPaymentsProcessed"
import PaymentAccountSelect from "./PaymentAccountSelect"

const PaymentProcessingPayments = () => {
    const merchantID = useSelector((state: RootState) => state.paymentProcessing.merchantID)
    const dispatch = useDispatch()

    SideBar.activateMenu("payment-processing")

    const [dataFilters, setDataFilters] = useState<string>("")
    const {
        hasActiveAccount,
        isLoading: isLoadingPaymentAccounts,
        paymentAccounts: paymentAccounts,
        merchantID : defaultMerchantID
    } = useGetPaymentAccounts()
    const { session, isLoading: isLoadingSession } = usePaymentAccountSessionByMerchantId(SESSION_TYPE.READ_UPDATE_PAYIN, merchantID)
    const { data: paymentsCount, isLoading: isLoadingPaymentsCount } = useQuery(["getPaymentsCount", merchantID], async () => {
        return PaymentProcessingService.getPaymentsCount(merchantID, INTEGRATION_KEY.RAINFOREST)
    }, {
        enabled: !!merchantID
    })

    const { isOpen, openModal, closeModal } = useBaseModal()

    useEffect(() => {
        if (!merchantID) {
            dispatch(setMerchantID(paymentAccounts?.find(pa => pa.isActive())?.getMerchantId()
                || defaultMerchantID))
        }
    }, [paymentAccounts])

    useEffect(() => {
        const filters = JSON.stringify({
            merchant_id: merchantID,
        })
        setDataFilters(filters)
    }, [merchantID])

    if (!session || isLoadingSession || isLoadingPaymentAccounts || isLoadingPaymentsCount || !dataFilters) {
        return <LoadingSpinner />
    }

    const hasAllowedCurrency = GlobalHelper.getCountryCodeFromCurrency(AppContext.getCurrency()) === "US"
    const hasProcessedPayments = !!paymentsCount && paymentsCount.totalPaymentsCount > 0

    return (
        <>
            {!hasAllowedCurrency && <Redirect to={"/"} />}
            {!hasActiveAccount && <Redirect to={"/payment-processing/accounts"} />}
            {hasAllowedCurrency && hasActiveAccount && (
                <>
                    <PaymentProcessingTabs hasActiveAccount={hasActiveAccount} />

                    <div className="d-flex flex-column">
                        <div className="row">
                            <div className="col-8 col-md-8 d-flex start">
                                <h2 className="custom-lead pl-2 mb-0">
                                    <FormattedMessage
                                        id="payment_processing.payment_listing.header"
                                        defaultMessage="Processed Payments"
                                    />
                                </h2>
                            </div>
                            <div className="col-4 col-md-4 justify-content-end pr-4">
                                <PaymentAccountSelect />
                            </div>
                        </div>
                    </div>

                    {!hasProcessedPayments ?
                        <NoPaymentsProcessed />
                        :
                        <div className="d-flex flex-column">

                            <button className="btn btn-sm btn-link align-self-end" onClick={openModal}>
                                <Icon className={"mr-1"} value={"plus-square"} />
                                <FormattedMessage
                                    id="payment_processing.payment_listing.status"
                                    defaultMessage="What does the payment status mean?"
                                />
                            </button>
                            <PaymentStatusesModal isOpen={isOpen} onClose={closeModal} />
                            <>
                                {/* @ts-ignore */}
                                <rainforest-payment-report
                                    key={dataFilters}
                                    session-key={session.getSessionKey()}
                                    data-filters={dataFilters}
                                    style-font-family={"\"Work Sans\", sans-serif"}
                                    hide-actions
                                    show-export-button
                                    columns='[
                                            {"name":"Created","type":"builtin","value":"created"},
                                            {"name":"Type","type":"builtin","value":"type"},
                                            {"name":"Status","type":"builtin","value":"status"},
                                            {"name":"Document","type":"metadata","value":"$.identifier"},
                                            {"name":"Amount","type":"builtin","value":"amount"},
                                            {"name":"Customer","type":"builtin","value":"name"},
                                            {"name":"Method","type":"builtin","value":"method"},
                                            {"name":"Merchant Name","type":"builtin","value":"merchant_name"}
                                        ]'
                                />
                            </>
                        </div>
                    }
                </>
            )}
        </>
    )
}

export default PaymentProcessingPayments


// WEBPACK FOOTER //
// ./src/payment-processing/payment-listing/PaymentProcessingPayments.tsx